import type { MedicalCheckupFrequency } from '@/_graphql/graphql-client'

export type MedicalRole = typeof medicalRole[number]
export type MedicalStatus = typeof medicalStatus[number]
export type MedicalSubject = typeof medicalSubjects[number]

export const medicalRole = ['歯科医師', '歯科衛生士', '受付'] as const
export const medicalStatus = ['有効', '無効', '保留'] as const
export const medicalSubjects = ['歯科', '医科'] as const 